
















































import { Component, Vue } from "vue-property-decorator";
import fb from '@/firebaseConfig';
import { ResultCache, MemberChamp, ChampCatCount} from 'jsk-shared';

@Component({})
export default class ChampTable extends Vue {
  search: string = "";
  loading: boolean = true;
  champSet: MemberChamp[] = [];
  headers = [
    {
      text: "Name",
      align: "left",
      value: "MemberName"
    },
    { text: "Completed", value: "IsComplete" },
    { text: "Progress", value: "", class: "hidden-sm-and-down" },
    { text: "Action", value: "EventsReview", align: "right" },
    {
      text: "SHORT",
      class: "hidden-sm-and-down",
      value: "ChampCatCount.SHORT"
    },
    {
      text: "MEDIUM",
      class: "hidden-sm-and-down",
      value: "ChampCatCount.MEDIUM"
    },
    { text: "LONG", class: "hidden-sm-and-down", value: "ChampCatCount.LONG" },
    {
      text: "OTHER",
      class: "hidden-sm-and-down",
      value: "ChampCatCount.OTHER"
    },
    {
      text: "Total Events",
      class: "hidden-sm-and-down",
      value: "ChampEvents.length"
    }
  ];
  rowConfig= [
    10,
    25,
    50,
    { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
  ];
  champResults: any = [];

  calcProgress(ChampCatCount: ChampCatCount) {
    let progress = 0;

    progress += ChampCatCount.SHORT >= 3 ? 3 : ChampCatCount.SHORT;
    progress += ChampCatCount.MEDIUM >= 2 ? 2 : ChampCatCount.MEDIUM;
    progress += ChampCatCount.LONG >= 2 ? 2 : ChampCatCount.LONG;
    progress += ChampCatCount.OTHER >= 1 ? 1 : ChampCatCount.OTHER;

    return progress * 12.5;
  }
  created() {
    this.loading = true;
    fb.db.doc("/cache/champCache").onSnapshot(doc => {
      let champs: any = doc.data();
      this.champSet = champs.champs as MemberChamp[];
      this.loading = false;
    });
  }
}
